import { Link } from "react-router";
import { ArrowLeft, Compass } from "lucide-react";

import { DocumentTitle } from "@/components/document-title";
import { buttonVariants } from "@/components/ui/button-variants";
import {
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from "@/components/ui/empty";

export function NotFound() {
  return (
    <main className="bg-muted/40 flex min-h-dvh items-center justify-center p-4">
      <DocumentTitle title="Page not found" />
      <Empty className="bg-background max-w-lg border">
        <EmptyHeader>
          <EmptyMedia variant="icon">
            <Compass />
          </EmptyMedia>
          <EmptyTitle>Page not found</EmptyTitle>
          <EmptyDescription>This admin page doesn’t exist or was moved.</EmptyDescription>
        </EmptyHeader>
        <EmptyContent>
          <Link to="/" className={buttonVariants()}>
            <ArrowLeft /> Back to overview
          </Link>
        </EmptyContent>
      </Empty>
    </main>
  );
}
